import { browserReplayIntegration } from "@sentry/react-native";

/** Session replay for web. Text and media are masked by default. */
export const replayIntegration = () => browserReplayIntegration();
